import React from 'react';
import { graphql } from 'gatsby';

import GlobalLayout from '../components/common/Layout';

import AboutComponent from '../components/about';
import SeoHelmet from '../components/common/SeoHelmet';

const AboutTemplate = ({ data: { markdownRemark } }) => {
  const {
    fields: { slug: url },
    frontmatter: { hero, seo, whoWeAre, legal, notice, awardsSections }
  } = markdownRemark;

  return (
    <GlobalLayout white={hero.whiteNavigation} fixedHeader={hero.fixedHeader} {...{ legal, margin: false, notice }}>
      <SeoHelmet {...{ ...seo, url }} />
      <AboutComponent {...{ hero, whoWeAre, awardsSections }} />
    </GlobalLayout>
  );
};

export const pageQuery = graphql`
  query AboutPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      fields {
        slug
      }
      frontmatter {
        seo {
          title
          description
          image
        }
        hero {
          title
          subtitle
          image
          whiteNavigation
          fixedHeader
        }
        whoWeAre {
          title
          image
          imageWidth
          imageHeight
          text
        }
        awardsSections {
          title
          awards {
            image
            imageAlt
            url
            description
          }
        }
        legal
        notice
      }
    }
  }
`;

export default AboutTemplate;
